import { useAppSelector } from "../../../services/redux/hooks/use-selector";
import { selectCaseAiScoring } from "../redux/selectors";

export const useAiScoringById = () => {
  const aiScoring = useAppSelector(selectCaseAiScoring);
  const {
    task_description,
    input_artifact,
    output_artifact,
    consumer,
    skills,
    knowledge,
    summary,
  } = aiScoring;

  return {
    aiScoring,
    task_description,
    input_artifact,
    output_artifact,
    consumer,
    skills,
    knowledge,
    summary,
  };
};
